// extracted by mini-css-extract-plugin
export default {"root":"ErrorMessage_root__3ZneJ","el":"ErrorMessage_el__2bnwA"};